import React from 'react';

interface IFacebookProps {
    height: string
    url: string
}

//350 je minimum, co FB dovoluje
const WIDTH = 350;

function Facebook({ height, url }: IFacebookProps) {
    return (
        <div className="stx-media-wrapper">
            {
                // eslint-disable-next-line jsx-a11y/iframe-has-title
                <iframe
                    className='stx-chatbot-chat-facebook'
                    src={`https://www.facebook.com/plugins/post.php?href=${encodeURIComponent(url)}&show_text=true&width=${WIDTH}`}
                    width={WIDTH}
                    height={height}
                    style={{ border: 'none', overflow: 'hidden' }}
                    scrolling="yes"
                    frameBorder="0"
                    allowFullScreen={true}
                    allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                />
            }
        </div>
    );
}

export default Facebook;
